import React from 'react'
import * as bs4 from 'reactstrap'
import 'bootstrap/dist/css/bootstrap.min.css';
import Select from 'react-dropdown-select'
import Navbar from '../Navbar'
import "../../../node_modules/react-datepicker/dist/react-datepicker.css";
import ReactGA from 'react-ga';
import { ScaleLoader } from 'react-spinners';
const { proxy } = require('../../ip_api.config')

class Acc_CreateItem extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            item_no: '',
            description: '',
            arr_item: [],
            arr_check: [],
            arr_save: [],
            arr_temp: [],
            show_item: '',
            isLoading: false,
            modal: false
        }
    }

    componentDidMount() {
        ReactGA.initialize('UA-176717650-5');
        ReactGA.pageview('/Acc/CreateItem');

        if (localStorage.getItem("ID_User") !== null) {
            this.getMaster_Option()
        } else {
            this.props.history.push({
                pathname: '/'
            })
        }
    }

    getMaster_Option = () => {
        this.setState({ isLoading: true, onPage: 'Preview' })
        let arrIbrand1 = []
        let arrIbrand3 = []
        let arrIbrand4 = []
        let arrUnit = []
        let arrLocationProduction = []
        let arrLocationPack = []
        let url = proxy.server + '/acc/getMaster_Option'
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({
                id: '',
                type: ''
            })
        })
            .then(response => response.json())
            .then((responseJson) => {
                responseJson.result.map(function (val, i) {
                    if (val.type === 'Ibrand1' || val.type === 'ibrand1') {
                        arrIbrand1.push({ value: val.code, label: val.code })
                    } else if (val.type === 'Ibrand3' || val.type === 'ibrand3') {
                        arrIbrand3.push(<option value={val.code}>{val.code}</option>)
                    } else if (val.type === 'Ibrand4' || val.type === 'ibrand4') {
                        arrIbrand4.push(<option value={val.code}>{val.code}</option>)
                    } else if (val.type === 'Unit' || val.type === 'unit') {
                        arrUnit.push(<option value={val.code}>{val.code}</option>)
                    } else if (val.type === 'LocationProduction' || val.type === 'locationProduction') {
                        arrLocationProduction.push(<option value={val.code}>{val.code}</option>)
                    } else if (val.type === 'LocationPack' || val.type === 'locationPack') {
                        arrLocationPack.push(<option value={val.code}>{val.code}</option>)
                    }
                }, this)
                this.setState({ isLoading: false, optionIbrand1: arrIbrand1, optionIbrand3: arrIbrand3, optionIbrand4: arrIbrand4, optionUnit: arrUnit, optionLocationProduction: arrLocationProduction, optionLocationPack: arrLocationPack })
            })
    }

    checkItem = (db, check, item_no) => {
        if (check === true) {
            let data = {
                db_name: db,
                item_no: item_no
            }
            let arr = this.state.arr_check.concat(data)
            this.setState({
                arr_check: arr
            }, () => {
                this.showItem(0)
            })
        } else {
            let arr = this.state.arr_check

            for (var i = arr.length; i--;) {
                if (arr[i].db_name === db && arr[i].item_no === item_no) arr.splice(i, 1);
            }
            this.setState({
                arr_check: arr
            }, () => {
                this.showItem(0)
            })
        }
    }

    addItem = () => {
        const { arr_temp, item_no, description } = this.state
        let checkItem = true

        arr_temp.map(function (val, i) {
            if (val.item_no === item_no) {
                checkItem = false
            }
        })


        if (checkItem === true) {
            if (item_no === "" || description === "") {
                alert('กรุณากรอกข้อมูลให้ครบ')
            } else {
                let arr = []
                let temp
                let data = {
                    item_no: item_no,
                    description: description,
                    production_location: '',
                    pack_location: '',
                    type1: '',
                    brand: '',
                    item_g1: '',
                    item_g2: '',
                    item_g3: '',
                    item_g4: '',
                    ibrand1: '',
                    ibrand2: '',
                    ibrand3: '',
                    ibrand4: '',
                    poduct_type: '',
                    type2: '',
                    category: '',
                    cost_group_id: '',
                    unit: '',
                    additional: '',
                    item_buyer: '',
                    item_disc_group: '',
                    production: '',
                    cost_group: '',
                    invent_buy: '',
                    invent_collect: '',
                    invent_sale: '',
                    image: ''
                }

                arr.push(data)

                temp = arr_temp.concat(arr)

                this.setState({
                    arr_temp: temp,
                    item_no: "",
                    description: ""
                }, () => {
                    this.preCheckItem(item_no)
                })
            }
        } else {
            alert('ไม่สมารถเพิ่มได้ เนื่องจากมีไอเท็มซ้ำ')
        }
    }

    preCheckItem = (item_no) => {
        let data = [
            {
                db_name: 'DPL',
                item_no: item_no
            }
        ]
        let arr = this.state.arr_check.concat(data)
        this.setState({
            arr_check: arr
        }, () => {
            this.showItem(1)
        })
    }

    showItem = (num) => {
        let arr = []
        this.state.arr_temp.map(function (val, i) {
            const typeItem = val.item_no.substr(0, 2) === "GF" || val.item_no.substr(0, 2) === "WA" ? "GIFT" : "G"

            let checkboxDBDPL = <bs4.FormGroup check style={{ marginRight: 20 }}>
                <bs4.Label check>
                    <bs4.Input type="checkbox" style={{ width: 25, height: 25 }} onChange={(e) => this.checkItem('DPL', e.target.checked, val.item_no)} />{' '}
                    <bs4.Label style={{ fontSize: '16px', fontWeight: 500, marginLeft: 20 }}>DPL</bs4.Label>
                </bs4.Label>
            </bs4.FormGroup>
            let checkboxDBDFIX = <bs4.FormGroup check style={{ marginRight: 20 }}>
                <bs4.Label check>
                    <bs4.Input type="checkbox" style={{ width: 25, height: 25 }} onChange={(e) => this.checkItem('DFIX', e.target.checked, val.item_no)} />{' '}
                    <bs4.Label style={{ fontSize: '16px', fontWeight: 500, marginLeft: 20 }}>DFIX</bs4.Label>
                </bs4.Label>
            </bs4.FormGroup>
            let checkboxDBDPT = <bs4.FormGroup check style={{ marginRight: 50 }}>
                <bs4.Label check>
                    <bs4.Input type="checkbox" style={{ width: 25, height: 25 }} onChange={(e) => this.checkItem('DPT', e.target.checked, val.item_no)} />{' '}
                    <bs4.Label style={{ fontSize: '16px', fontWeight: 500, marginLeft: 20 }}>DPT</bs4.Label>
                </bs4.Label>
            </bs4.FormGroup>

            let type1 = typeItem === "GIFT" ? val.item_no.substr(0, 2) : val.item_no.charAt(0)
            let brand = typeItem === "GIFT" ? val.item_no.substr(3, 2) : val.item_no.substr(1, 2)
            let item_g1 = typeItem === "GIFT" ? val.item_no.substr(0, 2) : val.item_no.substr(0, 3)
            let item_g2 = typeItem === "GIFT"
                ? val.item_no.substr(6, 2)
                : val.item_no.charAt(0) === 'P' || val.item_no.charAt(0) === 'U' ? val.item_no.charAt(4) : val.item_no.substr(3, 2)
            let item_g3 = typeItem === "GIFT" ? "" : val.item_no.charAt(0) === 'U' ? '02'
                : val.item_no.charAt(0) === 'P' ? '01'
                    : val.item_no.charAt(1) + val.item_no.charAt(2) === '04' ? ''
                        : val.item_no.charAt(6) === '-' ? val.item_no.substr(5, 1) : val.item_no.substr(5, 2)
            let type2 = type1 === 'G' ? 'FG' : type1 === 'H' ? 'HP' : type1 === 'S' ? 'SM' : type1 === 'P' ? 'PK' : type1 === 'U' ? 'SU' : 0
            let product_type = type2 === 'FG' || type2 === 'HP' || type2 === 'SM' ? 'Production' : 'Purchase Order'
            let category = type2 === 'FG' ? 'Finished Goods'
                : type2 === 'HP' ? 'SEMI Pack Oversea'
                    : type2 === 'SM' ? 'Semi Product'
                        : type2 === 'PK' ? 'Packaging'
                            : type2 === 'SU' ? 'Supply'
                                : type2 === 'RM' ? 'Raw Material'
                                    : type2 === 'WF' ? 'Voucher'
                                        : type2 === 'FS' ? 'Factory Supply'
                                            : type2 === 'FA' ? 'Fixed Assets'
                                                : type2 === 'SV' ? 'Service item' : ''
            let cost_group_id = typeItem === "GIFT" ? "" : item_g3 === '01' || item_g3 === '03' ? 'PM' : 'MT'
            let additional = type2 === 'SM' ? '2' : type2 === 'PK' || type2 === 'SU' ? '10' : ''
            let item_buyer = type1 === 'G' || type1 === 'H' ? ''
                : this.state.arr_temp[i] !== undefined ? this.state.arr_temp[i].production_location === 'จีน' ? 'CN'
                    : this.state.arr_temp[i].production_location === 'Difu' || this.state.arr_temp[i].production_location === 'สังขละ' ? 'CN-FAC' : 'TH' : ''
            let production = this.state.arr_temp[i] !== undefined ? this.state.arr_temp[i].production_location === 'สังขละ' ? 'PD-ABS' : 'PD-PACK' : ''
            let cost_group = brand === '01' || brand === '02' ? 'PG01' : 'PG03'
            let invent_buy = 'SRM'
            let invent_collect = 'WRM'
            let invent_sale = 'WRM'
            let ibrand1 = typeItem === "GIFT" ? val.item_no.substr(3, 2) : ""
            let ibrand2 = typeItem === "GIFT" ? val.item_no.substr(3, 2) : ""

            this.state.arr_check.map(function (el, j) {
                if (el.item_no === val.item_no) {
                    if (el.db_name === 'DPL') {
                        checkboxDBDPL = <bs4.FormGroup check style={{ marginRight: 20 }}>
                            <bs4.Label check>
                                <bs4.Input type="checkbox" style={{ width: 25, height: 25 }} onChange={(e) => this.checkItem('DPL', e.target.checked, val.item_no)} checked />{' '}
                                <bs4.Label style={{ fontSize: '16px', fontWeight: 500, marginLeft: 20 }}>DPL</bs4.Label>
                            </bs4.Label>
                        </bs4.FormGroup>
                    } else if (el.db_name === 'DFIX') {
                        checkboxDBDFIX = <bs4.FormGroup check style={{ marginRight: 20 }}>
                            <bs4.Label check>
                                <bs4.Input type="checkbox" style={{ width: 25, height: 25 }} onChange={(e) => this.checkItem('DFIX', e.target.checked, val.item_no)} checked />{' '}
                                <bs4.Label style={{ fontSize: '16px', fontWeight: 500, marginLeft: 20 }}>DFIX</bs4.Label>
                            </bs4.Label>
                        </bs4.FormGroup>
                    } else if (el.db_name === 'DPT') {
                        checkboxDBDPT = <bs4.FormGroup check style={{ marginRight: 50 }}>
                            <bs4.Label check>
                                <bs4.Input type="checkbox" style={{ width: 25, height: 25 }} onChange={(e) => this.checkItem('DPT', e.target.checked, val.item_no)} checked />{' '}
                                <bs4.Label style={{ fontSize: '16px', fontWeight: 500, marginLeft: 20 }}>DPT</bs4.Label>
                            </bs4.Label>
                        </bs4.FormGroup>
                    }
                }
            }, this)

            arr.push(
                <tr>
                    <td><bs4.Button color='danger' size='sm' onClick={() => this.onDelete(i, val.item_no)}>DEL</bs4.Button></td>
                    <td>
                        {checkboxDBDPL}
                        {checkboxDBDFIX}
                        {checkboxDBDPT}
                    </td>
                    <td style={{ fontWeight: 600 }}> <bs4.Col sm='12' style={{ width: 150 }}>{val.item_no}</bs4.Col></td>
                    <td style={{ fontWeight: 600 }}><bs4.Col sm='12' style={{ width: 200 }}>{val.description}</bs4.Col></td>
                    <td>
                        <bs4.Col sm='12' style={{ width: 200 }}>
                            <bs4.Input type="select" name="production_location" onChange={(e) => this.handleChangeItem(i, e.target.name, e.target.value)}>
                                <option value="">เลือกผลิตที่</option>
                                {this.state.optionLocationProduction}
                            </bs4.Input>
                        </bs4.Col>
                    </td>
                    <td>
                        <bs4.Col sm='12' style={{ width: 200 }}>
                            <bs4.Input type="select" name="pack_location" onChange={(e) => this.handleChangeItem(i, e.target.name, e.target.value)}>
                                <option value="">เลือกสถานที่แพ็ค</option>
                                {this.state.optionLocationPack}
                            </bs4.Input>
                        </bs4.Col>
                    </td>
                    <td style={{ fontWeight: 600 }}>{type1}</td>
                    <td style={{ fontWeight: 600 }}>{brand}</td>
                    <td style={{ fontWeight: 600 }}>{item_g1}</td>
                    <td style={{ fontWeight: 600 }}>{item_g2}</td>
                    <td style={{ fontWeight: 600 }}>{typeItem === "GIFT"
                        ? <bs4.Col sm='12' style={{ width: 200 }}>
                            <bs4.Input type="text" name="item_g3" onChange={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} />
                        </bs4.Col>
                        : item_g3}</td>
                    <td style={{ fontWeight: 600 }}>
                        <bs4.Col sm='12' style={{ width: 200 }}>
                            <bs4.Input type="text" name="item_g4" onChange={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} />
                        </bs4.Col>
                    </td>
                    <td style={{ fontWeight: 600 }}>
                        {
                            typeItem === "GIFT"
                                ? ibrand1
                                : <bs4.Col sm='12' style={{ width: 200 }}>
                                    <Select className="col-md-12"
                                        onChange={(e) => this.setState({ selectedOption: e }, () => this.handleChangeItem(i, 'ibrand1', e[0].value))}
                                        options={this.state.optionIbrand1}
                                        placeholder={'ค้นหา Item'}
                                    />
                                </bs4.Col>
                        }
                    </td>
                    <td style={{ fontWeight: 600 }}>
                        {
                            typeItem === "GIFT"
                                ? ibrand2
                                : <bs4.Col sm='12' style={{ width: 200 }}>
                                    <bs4.Input type="text" name="ibrand2" maxLength="20" onChange={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} />
                                </bs4.Col>
                        }
                    </td>
                    <td>
                        <bs4.Col sm='12' style={{ width: 200 }}>
                            <bs4.Input type="text" name="ibrand3" maxLength="20" onChange={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} />
                        </bs4.Col>
                    </td>
                    <td>
                        <bs4.Col sm='12' style={{ width: 200 }}>
                            <bs4.Input type="text" name="ibrand4" maxLength="20" onChange={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} />
                        </bs4.Col>
                    </td>
                    <td style={{ fontWeight: 600 }}>{product_type}</td>
                    <td style={{ fontWeight: 600 }}>{type2}</td>
                    <td style={{ fontWeight: 600 }}>{category}</td>
                    <td style={{ fontWeight: 600 }}>{typeItem === "GIFT" ? val.cost_group_id : cost_group_id}</td>
                    <td>
                        <bs4.Col sm='12' style={{ width: 200 }}>
                            <bs4.Input type="select" name="unit" onChange={(e) => this.handleChangeItem(i, e.target.name, e.target.value)}>
                                <option value="">เลือก Unit</option>
                                {this.state.optionUnit}
                            </bs4.Input>
                        </bs4.Col>
                    </td>
                    <td style={{ fontWeight: 600 }}>{additional}</td>
                    <td style={{ fontWeight: 600 }}>{item_buyer}</td>
                    <td style={{ fontWeight: 600 }}>{val.item_disc_group}</td>
                    <td style={{ fontWeight: 600 }}>{production}</td>
                    <td style={{ fontWeight: 600 }}>{cost_group}</td>
                    <td style={{ fontWeight: 600 }}>{invent_buy}</td>
                    <td style={{ fontWeight: 600 }}>{invent_collect}</td>
                    <td style={{ fontWeight: 600 }}>{invent_sale}</td>
                    <td>
                        <bs4.Col sm='12' style={{ width: 200 }}>
                            <bs4.Input type="text" name="barcode" onChange={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} />
                        </bs4.Col>
                    </td>
                    <td> <bs4.Col sm='12' style={{ width: 250 }}><bs4.Input type="file" name="image" /></bs4.Col></td>
                </tr>
            )

            if (num !== 0) {
                this.state.arr_temp[i].type1 = type1
                this.state.arr_temp[i].brand = brand
                this.state.arr_temp[i].item_g1 = item_g1
                this.state.arr_temp[i].item_g2 = item_g2
                this.state.arr_temp[i].item_g3 = item_g3
                this.state.arr_temp[i].poduct_type = product_type
                this.state.arr_temp[i].type2 = type2
                this.state.arr_temp[i].category = category
                this.state.arr_temp[i].cost_group_id = typeItem === "GIFT" ? val.cost_group_id : cost_group_id
                this.state.arr_temp[i].additional = additional
                this.state.arr_temp[i].item_buyer = item_buyer
                this.state.arr_temp[i].item_disc_group = val.item_disc_group
                this.state.arr_temp[i].production = production
                this.state.arr_temp[i].cost_group = cost_group
                this.state.arr_temp[i].invent_buy = invent_buy
                this.state.arr_temp[i].invent_collect = invent_collect
                this.state.arr_temp[i].invent_sale = invent_sale
                this.state.arr_temp[i].ibrand1 = ibrand1
                this.state.arr_temp[i].ibrand2 = ibrand2
            }
        }, this)

        this.setState({ show_item: arr, arr_temp: this.state.arr_temp })
    }

    handleChangeItem = (index, name, value) => {
        if (name === 'production_location') {
            this.state.arr_temp[index].production_location = value

            let item_buyer = this.state.arr_temp[index].type1 === 'G' || this.state.arr_temp[index].type1 === 'H' ? ''
                : this.state.arr_temp[index] !== undefined ? this.state.arr_temp[index].production_location === 'จีน' ? 'CN'
                    : this.state.arr_temp[index].production_location === 'Difu' || this.state.arr_temp[index].production_location === 'สังขละ' ? 'CN-FAC' : 'TH' : ''
            this.state.arr_temp[index].item_buyer = item_buyer

            let production = this.state.arr_temp[index] !== undefined ? this.state.arr_temp[index].production_location === 'สังขละ' ? 'PD-ABS' : 'PD-PACK' : ''
            this.state.arr_temp[index].production = production
        } else if (name === 'pack_location') {
            this.state.arr_temp[index].pack_location = value
            let invent_buy = 'SRM'
            this.state.arr_temp[index].invent_buy = invent_buy

        } else if (name === 'ibrand1') {
            this.state.arr_temp[index].ibrand1 = value
        } else if (name === 'ibrand2') {
            this.state.arr_temp[index].ibrand2 = value

            let item_disc_group = this.state.arr_temp[index] !== undefined ? this.state.arr_temp[index].type1 === 'G' ? this.state.arr_temp[index].ibrand2 : '' : ''
            this.state.arr_temp[index].item_disc_group = item_disc_group
        } else if (name === 'ibrand3') {
            this.state.arr_temp[index].ibrand3 = value
            this.state.arr_temp[index].item_disc_group = value
        } else if (name === 'ibrand4') {
            this.state.arr_temp[index].ibrand4 = value
        } else if (name === 'unit') {
            this.state.arr_temp[index].unit = value
        } else if (name === 'item_g4') {
            this.state.arr_temp[index].item_g4 = value
        } else if (name === 'barcode') {
            this.state.arr_temp[index].barcode = value
        } else if (name === 'item_g3') {
            this.state.arr_temp[index].item_g3 = value
            this.state.arr_temp[index].cost_group_id = value === '01' || value === '03' ? 'PM' : 'MT'
        }

        this.setState({
            arr_temp: this.state.arr_temp
        }, () => {
            this.showItem(0)
        })
    }

    onDelete = (index, item) => {
        const { arr_temp, arr_check } = this.state
        arr_temp.splice(index, 1)

        for (var i = arr_check.length; i--;) {
            if (arr_check[i].item_no === item) arr_check.splice(i, 1);
        }

        this.setState({
            arr_check: arr_check,
            arr_temp: arr_temp,
        }, () => {
            this.showItem(0)
        })
    }

    addItemDB = () => {
        this.setState({ isLoading: true })
        const { arr_save, arr_temp, arr_check } = this.state

        let arr = []
        let temp
        arr_temp.map(function (val, i) {
            arr_check.map(function (el, j) {
                if (val.item_no === el.item_no) {
                    let data = {
                        item_no: val.item_no,
                        description: val.description,
                        production_location: val.production_location,
                        pack_location: val.pack_location,
                        type1: val.type1,
                        brand: val.brand,
                        item_g1: val.item_g1,
                        item_g2: val.item_g2,
                        item_g3: val.item_g3,
                        item_g4: val.item_g4,
                        barcode: val.barcode,
                        ibrand1: val.ibrand1,
                        ibrand2: val.ibrand2,
                        ibrand3: val.ibrand3,
                        ibrand4: val.ibrand4,
                        poduct_type: val.poduct_type,
                        type2: val.type2,
                        category: val.category,
                        cost_group_id: val.cost_group_id,
                        unit: val.unit,
                        additional: val.additional,
                        item_buyer: val.item_buyer,
                        item_disc_group: val.item_disc_group,
                        production: val.production,
                        cost_group: val.cost_group,
                        invent_buy: val.invent_buy,
                        invent_collect: val.invent_collect,
                        invent_sale: val.invent_sale,
                        image: val.image,
                        db_name: el.db_name,
                        create_user: localStorage.getItem("ID_User"),
                        create_date: new Date()
                    }

                    arr.push(data)
                }
            }, this)
        }, this)

        temp = arr_save.concat(arr)

        this.setState({
            arr_save: temp
        }, () => {
            console.log('arr_save', this.state.arr_save)
            this.saveItem()
        })
    }

    saveItem = () => {
        if (window.confirm("กรุณายืนยันการบันทึก")) {
            let url = proxy.server + '/acc/insert_item'
            fetch(url, {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json;charset=utf-8"
                },
                body: JSON.stringify(this.state.arr_save)
            })
                .then(response => response.json())
                .then((responseJson) => {
                    // console.log("responseJson", responseJson)
                    if (responseJson.status === 201) {
                        this.reload()
                    } else {
                        this.setState({ arr_save: [] },
                            alert('ไม่สามารถบันทึกข้อมูลได้ กรุณาตรวจสอบข้อมูล')
                        )
                    }
                })
        }
    }

    reload = () => {
        window.location.reload()
    }

    render() {
        const { description, item_no, isLoading } = this.state
        return <div>
            < Navbar nav={'Acc'} menu={'Acc_CreatItem'} />
            <div style={{ marginLeft: 20, marginTop: 50, marginRight: 10 }}>
                <bs4.FormGroup row style={{ marginLeft: 20, marginTop: 20 }}>
                    <bs4.Label style={{ fontSize: '16px', fontWeight: 500 }}>Item No</bs4.Label>
                    <bs4.Col sm='4'>
                        <bs4.Input type="text" name="item_no" maxLength="20" value={item_no} onChange={(e) => e.target.value.length > 20 ? alert('ห้ามกรอกเกิน 20 ตัวอักษร') : this.setState({ item_no: e.target.value })} />
                    </bs4.Col>
                    <bs4.Label style={{ fontSize: '16px', fontWeight: 500 }}>Description</bs4.Label>
                    <bs4.Col sm='4'>
                        <bs4.Input type="text" name="description" maxLength="50" value={description} onChange={(e) => e.target.value.length > 60 ? alert('ห้ามกรอกเกิน 60 ตัวอักษร') : this.setState({ description: e.target.value })} />
                    </bs4.Col>
                    <bs4.Button style={{ fontWeight: 500 }} onClick={() => this.addItem()}>+ ADD</bs4.Button>
                    <bs4.Button color="warning" style={{ marginRight: 20, marginLeft: 20, fontWeight: 500 }} onClick={() => this.addItemDB()}>SAVE</bs4.Button>
                    <ScaleLoader
                        size={15}
                        loading={isLoading}
                    />
                    <ScaleLoader
                        size={15}
                        loading={isLoading}
                    />
                    <ScaleLoader
                        size={15}
                        loading={isLoading}
                    />
                </bs4.FormGroup>
                <br />
                <bs4.Table bordered hover style={{ fontSize: 15 }}>
                    <thead style={{ backgroundColor: '#8f8f8f', color: '#000' }}>
                        <tr style={{ textAlign: 'center' }}>
                            <th></th>
                            <th style={{ backgroundColor: '#fec23e', color: '#000' }}>ฐานข้อมูล</th>
                            <th style={{ backgroundColor: '#fec23e', color: '#000' }}>Item No.</th>
                            <th style={{ backgroundColor: '#fec23e', color: '#000' }}>Description</th>
                            <th style={{ backgroundColor: '#fec23e', color: '#000' }}>ผลิตที่</th>
                            <th style={{ backgroundColor: '#fec23e', color: '#000' }}>สถานที่แพ็ค</th>
                            <th>Type</th>
                            <th>Brand</th>
                            <th>Item G1</th>
                            <th>Item G2</th>
                            <th>Item G3</th>
                            <th>Item G4</th>
                            <th style={{ backgroundColor: '#fec23e', color: '#000' }}>Ibrand 1</th>
                            <th style={{ backgroundColor: '#fec23e', color: '#000' }}>Ibrand 2</th>
                            <th style={{ backgroundColor: '#fec23e', color: '#000' }}>Ibrand 3</th>
                            <th style={{ backgroundColor: '#fec23e', color: '#000' }}>Ibrand 4</th>
                            <th>ประเภทสินค้า</th>
                            <th>Type</th>
                            <th>Category</th>
                            <th>Cost Group ID</th>
                            <th style={{ backgroundColor: '#fec23e', color: '#000' }}>Unit</th>
                            <th>%Additional</th>
                            <th>Item Buyer</th>
                            <th>Item Disc Group</th>
                            <th>Production</th>
                            <th>Cost Group</th>
                            <th>คลังซื้อ</th>
                            <th>คลังจัดเก็บ</th>
                            <th>คลังขาย</th>
                            <th style={{ backgroundColor: '#fec23e', color: '#000' }}>Barcode</th>
                            <th>image</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.show_item}
                    </tbody>
                </bs4.Table>
            </div>
        </div >
    }
}

export default Acc_CreateItem